import * as React from 'react';
import * as _ from 'lodash';

import { Routes, useJourneyNavigation } from '../../../../routes';
import { LayerRenderEvent } from '../../../../layers/LayerManager';
import { LayerWidget } from '../../../../layers/LayerWidget';
import { ConfigureMFADialog } from './ConfigureMFADialog';

export const ConfigureMFADialogLayer: React.FC<{}> = () => {
  const handler = useJourneyNavigation(Routes.SETUP_MFA);
  const { params, navigate } = handler;

  const submitOrCancel = (event: LayerRenderEvent<Routes.SETUP_MFA>) => {
    navigate(Routes.PROFILE_SECURITY, params);
    event.layer.dispose();
  };

  return (
    <LayerWidget<Routes.SETUP_MFA>
      options={{ userCanExit: false, withBackdrop: true }}
      renderLayer={(event) => {
        return <ConfigureMFADialog onSubmitOrCancel={() => submitOrCancel(event)} />;
      }}
    />
  );
};
